/** Curated list of common countries for the country selector autocomplete. */
export const COUNTRIES = [
	"Argentina",
	"Australia",
	"Austria",
	"Belgium",
	"Brazil",
	"Canada",
	"Chile",
	"China",
	"Colombia",
	"Czech Republic",
	"Denmark",
	"Egypt",
	"Finland",
	"France",
	"Germany",
	"India",
	"Indonesia",
	"Ireland",
	"Israel",
	"Italy",
	"Japan",
	"Kenya",
	"Malaysia",
	"Mexico",
	"Netherlands",
	"New Zealand",
	"Nigeria",
	"Norway",
	"Philippines",
	"Poland",
	"Portugal",
	"Romania",
	"Saudi Arabia",
	"Singapore",
	"South Africa",
	"South Korea",
	"Spain",
	"Sweden",
	"Switzerland",
	"Thailand",
	"Turkey",
	"Ukraine",
	"United Arab Emirates",
	"United Kingdom",
	"United States",
	"Vietnam",
] as const;
